import { Controller } from "@hotwired/stimulus"

// Comment form + list display
// Values: url (the resource URL to POST to)
// Targets: textarea, submitBtn, list
export default class extends Controller {
  static values = { url: String }
  static targets = ["textarea", "submitBtn", "list"]

  submit(event) {
    event.preventDefault()

    const text = this.textareaTarget.value
    if (!text) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    this.submitBtnTarget.classList.add("-is-loading")
    this.submitBtnTarget.setAttribute("disabled", true)

    fetch(this.urlValue + "/comments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ text: text })
    })
      .then(response => response.json())
      .then(comment => {
        const html = this.renderComment(comment)
        this.listTarget.insertAdjacentHTML("afterbegin", html)
        this.textareaTarget.value = ""
        this.submitBtnTarget.classList.remove("-is-loading")
        this.submitBtnTarget.removeAttribute("disabled")
      })
  }

  renderComment(comment) {
    const date = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit"
    }).format(Date.parse(comment.created_at))

    return `<article class="comment-container">
      <label class="comment-name">
        <a href="/${this.escapeHtml(comment.user.name)}">${this.escapeHtml(comment.user.name)}</a>
      </label>
      &nbsp;&nbsp;
      <small class="comment-meta">
        <time datetime="${comment.created_at}">${date}</time>
      </small>
      <p class="comment-text">${this.escapeHtml(comment.text)}</p>
    </article>`
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
